import { format } from 'date-fns'

import { httpClient } from '@/services/http/httpClient'
import { getQueryParams, type QueryParams } from '@/utils/queryParams'

type HttpEvaluationResponse =
  | {
      id: string
      kanbanStepName: string
      idea: {
        id: string
        sequence: string
        title: string
        campaign: {
          title: string
        }
      }
      status: 'Pendente' | 'Concluído'
      type: 'criteria'
    }
  | {
      id: string
      deadline: string
      idea: {
        id: string
        title: string
        sequence: string
        campaign: {
          title: string
        }
      }
      kanbanStepName: string
      status: 'Pendente' | 'Concluído'
      type: 'technicalReview'
    }

type HttpMyEvaluationsResponse = {
  data: HttpEvaluationResponse[]
  paginate: {
    total: number
    page: number
    pages: number
    limit: number
  }
}

export type MyEvaluation = {
  id: string
  deadline: string
  idea: {
    id: string
    title: string
    sequence: string
    campaign: {
      title: string
    }
  }
  kanbanStepName: string
  status: 'Pendente' | 'Concluído'
  type: string
}

type GetMyEvaluationsResponse = {
  evaluations: MyEvaluation[]
  pagination: {
    total: number
    limit: number
    page: number
    pages: number
  }
}

type MyEvaluationsParams = {
  query: QueryParams
}

export async function getMyEvaluations({
  query,
}: MyEvaluationsParams): Promise<GetMyEvaluationsResponse> {
  const queryParams = getQueryParams(query)

  const { data } = await httpClient.get<HttpMyEvaluationsResponse>(
    `/users/me/evaluation-criterias?${queryParams}`,
  )

  const {
    data: evaluationsData = [],
    paginate: pagination = { limit: 0, total: 0, page: 0, pages: 0 },
  } = data

  const evaluations = evaluationsData
    .map((evaluation) => {
      if (evaluation.type === 'criteria') {
        return {
          id: evaluation.id,
          deadline: 'Sem prazo',
          idea: evaluation.idea,
          kanbanStepName: evaluation.kanbanStepName,
          status: evaluation.status,
          type: 'Critérios',
        }
      }

      return {
        id: evaluation.id,
        deadline: format(new Date(evaluation.deadline), 'dd/MM/yyyy'),
        idea: evaluation.idea,
        kanbanStepName: evaluation.kanbanStepName,
        status: evaluation.status,
        type: 'Parecer técnico',
      }
    })
    .filter((evaluation) => !!evaluation.id)

  return {
    evaluations,
    pagination,
  }
}
